import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  ProjectsFacade,
  SharedFacade,
  debounce,
  delayedFunctionCall,
  formatNumber,
  nonNegativeValidator,
  onKeyDown,
} from '@piqet-angular/data';
import {
  AccessPermissionService,
  CustomModalService,
  DISABLED_TRANSPORT_MESSAGE,
  DistanceTypeEnum,
  commonEnum,
  unitList,
} from '@piqet-angular/shared';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { GridIconComponent } from '../grid-icon/grid-icon.component';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { ProjectPackMaterialListDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-material-list/project-material-list-data-grid.service';
import { ProductIngredientDataGridService } from 'libs/features/src/lib/layout/projects/product-details/product-ingredients/product-ingredient-data-grid.service';
import { cloneDeep } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { BehaviorSubject, Observable, Subject, Subscription, forkJoin, take } from 'rxjs';
import { MapsAPILoader } from '@agm/core';
import { InlineActionButtonComponent } from '../inline-action-button/inline-action-button.component';
import { GridCellRendererComponent } from '../grid-cell-renderer/grid-cell-renderer.component';

@Component({
  selector: 'piqet-angular-new-product-ingredient',
  templateUrl: './new-product-ingredient.component.html',
  styleUrls: ['./new-product-ingredient.component.scss'],
})
export class NewProductIngredientComponent implements OnDestroy {
  pageNumber = 1;
  searchValue: any;
  selectedCities: any;
  manufactureProcessData: any;
  productIngredientForm!: FormGroup;
  ingredientDetailFormGroup: any;
  transportationFormGroup: any;
  ingredientItem: any;
  modalLable: any;
  productIngredientData: any;
  submitForIngredient = false;
  finalSubmit = false;
  countryItems: any;
  ingredientColumnDef: any;
  keyword = 'name';
  ingredientTransportColumnDef: any;
  frameworkComponents = {
    inlineActionButtonComponent: InlineActionButtonComponent,
    actionRenderer: ActionButtonComponent,
  };
  frameworkComponentsMainGrid = {
    inlineActionButtonComponent: InlineActionButtonComponent,
    GridCellRendererComponent: GridCellRendererComponent,
  };
  frameworkComponentsForIngredientTransport = {
    actionRenderer: ActionButtonComponent,
    iconsOfTransport: GridIconComponent,
  };
  selectCustom = false;
  selectDistance = false;
  selectLocation = false;
  isShowDistantField = false;
  isShowCustomTransportList = false;
  setDestinationsubmitted = false;
  distanceBlack = './assets/icons/BasedOnDistance.png';
  distanceWhite = './assets/icons/BasedOnDistanceWhite.png';
  locationBlack = './assets/icons/BasedOnLocations.png';
  loactionWhite = './assets/icons/BasedOnLocationsWhite.png';
  customBlack = './assets/icons/CustomScenarios.png';
  customWhite = './assets/icons/CustomScenariosWhite.png';
  transportaionId: any;
  transportaionIdArray: any = [];
  tempData: any = [];
  wholeData: any = [
    {
      displayName: 'Based on location',
      img: this.locationBlack,
      widthImg: 19,
      heightImg: 26,
      type: 'location',
      transportaionId: 2,
    },
    {
      displayName: 'Based on distance',
      img: this.distanceBlack,
      widthImg: 26,
      heightImg: 25,
      type: 'distance',
      transportaionId: 3,
    },
    {
      displayName: 'Custom freight scenarios',
      img: this.customBlack,
      widthImg: 22,
      heightImg: 26,
      type: 'custom',
      transportaionId: 4,
    },
  ];
  TransportationEnum = [
    { Description: 'Material Default', id: 1 },
    { Description: 'Manual Locations', display: 'location', id: 2 },
    { Description: 'Manual Distances', display: 'distance', id: 3 },
    { Description: 'Custom Transport Mode', display: 'custom', id: 4 },
  ];
  selectedBox: any;
  ingredientFieldValue: any;
  transportationDetailForm: any;
  customTransportList: any;
  isCustomTruck = false;
  setOriginsubmitted = false;
  processColumnDef: any;
  distanceProcessColumnDef: any;
  transportModeItems: any;
  customTruckItems: any;
  setManualDistanceSubmitted = false;
  customtransportScenarioItems: any;
  isShowPort = false;
  CustomtransportScenarioId: any;
  allCustomtransportScenarioId: any = [];
  customTransportDef: any;
  transportScenarioDataForDistance: any;
  transportModeId: any;
  originId: any;
  transportModeName: any;
  transportModeDescription: any;
  destinationData: any;
  setManualLocationDis: any;
  transportScenarioData: any = {
    transportModeId: 0,
    transportModeName: '',
    cityName: '',
    distance: '',
    originId: '',
  };
  componentSubmitted = false;
  transportIcons: any;
  manufacturingForm: any;
  energyProcessItems: any;
  isCustomProcess = false;
  submitForManufacture = false;
  manufactureItems: any;
  isCostTrunOff = false;
  manufactureColumnDefForCost: any;
  manufactureColumnDef: any;
  productIngredientItems: any;
  selectesCountry: any;
  transportCustomId: any;
  materialInfoData: any;
  materialInfoDataKey: any;
  materialInfoDataValues: any;
  materialname: any;
  ingredientId = 0;
  getCountryIdData = 0;
  isLoading = false;
  keywordAuto = '';
  selectedMaterial = false;
  supplier: any;
  manufactureItemsCustom: any;
  @Output() saveNewProductIngredientEvent = new EventEmitter<any>();
  @ViewChild('autoForOrigin') autoForOrigin: any;
  @ViewChild('autoForDestination') autoForDestination: any;
  @ViewChild('auto') auto: any;
  messageType: any;
  isValidPort: any;
  lastItem: any;
  percentageMassLoad: any;
  showEdit = false;

  // edit ingredient transport to converter
  checkIsOrginBtn = true;
  isCheckEditManudalDist = false;
  isCheckUpdateDestination = false;
  isCheckUpdateOrigin = false;
  subscriptionProductData!: Subscription;
  productIngredientEditData: any;
  setDestinationLocationData: any;
  getOriginAndDestinationEditData: any;
  subscriptionCheckDeleteRowData!: Subscription;
  subscriptionProductManudalDistanceData!: Subscription;
  ProducteditManualDistanceData: any;
  setApiResDistance = false;
  setManualLocationDisForNextRecord: any;
  customFreightSelectData: any;
  subscriptionSaveProjectManualDistanceIngredientData!: Subscription;
  clearInputFieldProjectRetailManualDistanceIngredient!: Subscription;
  editProductManufactureSubscription!: Subscription;
  deleteProductManufactureSubscription!: Subscription;
  seaDistance: any;
  unitList = unitList;
  disableSubmit = false;
  isRowEditable = false;
  ingredientComponent = '';
  isProductEmpty = true;
  parentOrder = 1;
  private searchSubject = new Subject<string>();
  private readonly debounceTimeMs = 300; // Set the debounce time (in milliseconds)
  search$!: Observable<string>;
  supplierId: any;
  isLoadingSupplier: any;
  searchSupplierList: any;
  editManufactureData: any;
  manufactureEditMode = false;
  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private accessService: AccessPermissionService,
    public projectFacade: ProjectsFacade,
    private projectService: ProjectsService,
    public sharedService: SharedService,
    private projectPackMaterialListDataGridService: ProjectPackMaterialListDataGridService,
    private productIngredientDataGridService: ProductIngredientDataGridService,
    private mapsAPILoader: MapsAPILoader,
    private spinnerService: NgxSpinnerService,
    private projectsService: ProjectsService,
    private customService: CustomService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.productIngredientData =
      this.modal?.modalService?.config?.initialState?.['newProductIngredient'];
    this.ingredientComponent = DISABLED_TRANSPORT_MESSAGE.replace('{type}', 'ingredient');
    this.modalLable = this.modal?.modalService?.config?.initialState?.['label'];
    this.processColumnDef =
      this.modal?.modalService?.config?.initialState?.['addTransportScenarioColDef'];
    this.distanceProcessColumnDef =
      this.modal?.modalService?.config?.initialState?.['distanceProcessColumnDef'];
    this.customTransportDef =
      this.modal?.modalService?.config?.initialState?.['customTransportColumnDef'];
    this.ingredientColumnDef =
      this.modal?.modalService?.config?.initialState?.['ingredientColumnDef'];
    (this.ingredientTransportColumnDef =
      this.productIngredientDataGridService.newProductIngredientTransportColumns()),
      (this.manufactureColumnDefForCost =
        this.productIngredientDataGridService.newProductIngredientManactureColumnsForCost());
    this.manufactureColumnDef =
      this.productIngredientDataGridService.newProductIngredientManactureColumns();
    this.sharedService.getLatestIngredientTrasnport(
      this.productIngredientData.productIngredientItems
    );
    this.ingredientItem = this.productIngredientData.ingredientItems;
    this.countryItems = this.productIngredientData.country;
    const updatedData = this.ingredientItem.map((parent: any) => ({
      ...parent,
      childItems: parent.childItems.map((child: any) => ({
        ...child,
        description: child.name,
      })),
    }));
    this.ingredientColumnDef[0].cellEditorParams['ingredientList'] = updatedData;
    this.ingredientColumnDef[2].cellEditorParams['unitList'] = unitList;
    this.ingredientColumnDef[3].cellEditorParams['countryList'] = this.countryItems;
    this.ingredientColumnDef[4].cellEditorParams['supplierList$'] = new BehaviorSubject(
      this.productIngredientData.suppliersItems
    );
    this.customTruckItems = this.productIngredientData.customTruckItems;
    this.transportModeItems = this.productIngredientData.transportModeItems;
    this.supplier = this.productIngredientData.suppliersItems;
    this.customtransportScenarioItems = this.productIngredientData.customtransportScenarioItems;
    this.energyProcessItems = this.productIngredientData.energyProcessItems;
    this.isCostTrunOff = !this.productIngredientData.isCostTrunOff;
    this.manufactureItems = this.energyProcessItems;
    this.manufactureItemsCustom = this.productIngredientData.fillingListiItems;
    this.parentOrder = this.productIngredientData?.newParentOrder || 1;
    this.getCountry();
    this.projectFacade.errorMessageForProductIngredient$.subscribe((error: any) => {
      this.checkValidation(error);
    });
    this.sharedService.disableAddRowBtnTrigger$.subscribe((error: any) => {
      this.checkEditingStatus(error);
    });
  }

  checkValidation(ingredientError: any): void {
    this.disableSubmit = !!ingredientError;
  }
  checkEditingStatus(err: any) {
    if (err == 'editingStarted') {
      this.isRowEditable = true;
    } else if (err == 'editingStopped') {
      this.isRowEditable = false;
    }
  }

  async fingOriginAndDestination(x: any) {
    this.getOriginAndDestinationEditData = x;
    if (this.checkIsOrginBtn) {
      this.isCheckUpdateOrigin = true;
      this.transportationDetailForm.patchValue({ Origin: this.getOriginAndDestinationEditData });
    } else {
      this.isCheckUpdateDestination = true;
      this.transportationDetailForm.patchValue({
        destination: this.getOriginAndDestinationEditData,
      });
    }
  }

  ngOnInit() {
    this.showEdit = this.accessService.hasPermission('edit', '');
    this.projectFacade.locationProcessData$.pipe(take(1)).subscribe((data: any) => {
      this.checkIsOrginBtn = false;
    });
    this.search$ = debounce(this.searchSubject.asObservable(), this.debounceTimeMs);
    this.search$.subscribe(searchValue => {
      this.searchCities(searchValue);
    });

    this.productIngredientDataGridService.checkIngredinetDeleteData$.subscribe((check: any) => {
      this.transportationDetailForm.controls['ingredientTransportation'].reset();
    });
    this.subscriptionSaveProjectManualDistanceIngredientData =
      this.productIngredientDataGridService.saveProjectManualDistanceIngredientData$.subscribe(
        (editData: any) => {
          this.projectFacade.locationProcessData$.pipe(take(1)).subscribe(async (data: any) => {
            data?.length == 1 && editData[1] == 'manualLocation'
              ? this.setOrigin()
              : editData[1] == 'manualLocation'
              ? this.setDestination()
              : this.addTransportDistance();
          });
        }
      );

    this.editProductManufactureSubscription =
      this.productIngredientDataGridService.editProductManufactureSub$.subscribe(
        editManufactureData => {
          this.manufactureEditMode = true;
          this.editManufactureData = editManufactureData.data;
          this.bindManufactureForm(editManufactureData.data, editManufactureData.isCostOn);
        }
      );

    this.deleteProductManufactureSubscription =
      this.productIngredientDataGridService.deleteProductManufactureSub$.subscribe(
        editManufactureData => {
          this.projectFacade.proudctIngredientManufactureProcess(editManufactureData, 'delete');
          this.manufacturingForm.controls['processName'].setValue(null);
          this.manufacturingForm.controls['amount'].setValue('');
          this.manufacturingForm.controls['costPerPackage'].setValue(0);
          this.manufacturingForm.controls['costPerUnit']?.setValue(0);
          this.manufactureEditMode = false;
        }
      );

    this.clearInputFieldProjectRetailManualDistanceIngredient =
      this.productIngredientDataGridService.clearInputFieldProjectManualDistanceIngredientData$.subscribe(
        (check: any) => {
          this.transportationDetailForm.controls['Origin'].setValue(null);
          this.transportationDetailForm.controls['destination'].setValue(null);
          this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
          this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
          this.transportationDetailForm.controls['distance'].setValue('');
          this.isCheckUpdateDestination = false;
          this.isCheckUpdateOrigin = false;
          this.isCheckEditManudalDist = false;
          this.checkIsOrginBtn = false;
        }
      );
    this.subscriptionCheckDeleteRowData =
      this.productIngredientDataGridService.checkDeleteRowProductData$.subscribe((check: any) => {
        this.transportationDetailForm.controls['Origin'].setValue(null);
        this.transportationDetailForm.controls['destination'].setValue(null);
        this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
        this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
        this.transportationDetailForm.controls['distance'].setValue('');
        this.isCheckUpdateDestination = false;
        this.isCheckUpdateOrigin = false;
        this.isCheckEditManudalDist = false;
        check[2] && check[0].length > 0 && this.deleteSetDistanceRecord(check[0], check[1]);
      });

    this.subscriptionProductManudalDistanceData =
      this.productIngredientDataGridService.editProductSubManualDistanceSub$.subscribe(
        (editData: any) => {
          this.ProducteditManualDistanceData = editData;
          this.isCustomTruck = editData.isCustomTruck;
          this.transportModeId = editData.transportModeId;
          this.isCheckEditManudalDist = true;
          this.transportationDetailForm.controls['distance'].setValue(editData.distance);
          const location = editData.isCustomTruck ? this.customTruckItems : this.transportModeItems;
          const locationId = editData.isCustomTruck
            ? editData.customTruckId
            : editData.transportModeId;
          location.map((x: any) => {
            if (x.id == locationId) {
              this.setDestinationLocationData = x;
              this.transportationDetailForm.patchValue({
                transportModeForDistance: this.setDestinationLocationData,
              });
            }
          });
        }
      );

    this.subscriptionProductData =
      this.productIngredientDataGridService.editProductSubData$.subscribe(async (editData: any) => {
        this.productIngredientEditData = editData[0];
        this.transportModeId = editData[0].transportModeId;
        this.isCustomTruck = editData[0].isCustomTruck;
        const distanceManualLocationvalue =
          typeof editData[0].distance === 'string'
            ? editData[0]?.distance?.substring(0, editData[0]?.distance?.indexOf(' '))
            : 0;
        this.transportationDetailForm.controls['distanceManulaLocation'].setValue(
          distanceManualLocationvalue
        );
        if (editData[1]) {
          this.projectFacade.locationProcessData$.pipe(take(1)).subscribe(async (data: any) => {
            this.checkIsOrginBtn = data.length <= 1 ? true : false;
          });
          editData[0] = { ...editData[0] };
          editData[0].name = editData[0].originName;
          await this.fingOriginAndDestination(editData[0]);
          this.getLastItem();
          const location = editData[0].isCustomTruck
            ? this.customTruckItems
            : this.transportModeItems;
          const locationId = editData[0].isCustomTruck
            ? editData[0].customTruckId
            : editData[0].transportModeId;
          location.map((x: any) => {
            if (x.id == locationId) {
              this.setDestinationLocationData = x;
              this.transportationDetailForm.patchValue({
                transportModeForLocation: this.setDestinationLocationData,
              });
            }
          });
        }
      });
    this.productIngredientForm = this.formBuilder.group({
      ingredientDetailFormGroup: this.formBuilder.group({
        ingredientName: [null, Validators.required],
        ingredientWeigth: [
          null,
          [Validators.required, nonNegativeValidator, Validators.maxLength(100)],
        ],
        ingredientUnit: [null, Validators.required],
        ingredientCountry: [null],
        ingredientSupplier: [null],
      }),
      transportationDetailForm: this.formBuilder.group({
        ingredientTransportation: [null, Validators.required],
        Origin: [null],
        destination: [null],
        transportModeForLocation: [null],
        transportModeForDistance: [null],
        distanceManulaLocation: [''],
        distance: [''],
        customScenarioItem: [null],
      }),
      manufacturingForm: this.formBuilder.group({
        processName: [null, Validators.required],
        amount: ['', [Validators.required, nonNegativeValidator, Validators.maxLength(100)]],
        costPerUnit: [0, Validators.maxLength(100)],
        costPerPackage: [0],
      }),
    });
    this.ingredientDetailFormGroup =
      this.productIngredientForm.controls['ingredientDetailFormGroup'];
    this.transportationDetailForm = this.productIngredientForm.controls['transportationDetailForm'];
    this.manufacturingForm = this.productIngredientForm.controls['manufacturingForm'];
    this.transportationDetailForm.controls['ingredientTransportation'].valueChanges.subscribe(
      (value: any) => {
        this.isProductEmpty = !value || value.length === 0;
      }
    );
    this.setFormData();
    this.getIngrientInfo();
  }

  bindManufactureForm(data: any, isCostOn: any) {
    this.isCustomProcess = data.isCustomFilling;
    this.manufactureItems = data.isCustomFilling
      ? this.manufactureItemsCustom
      : this.energyProcessItems;
    const id = data.isCustomFilling ? data.customFillingId : data?.energyProcessId;

    // Handle grouped data structure with childItems
    let foundItem = null;

    for (const parent of this.manufactureItems) {
      if (parent.childItems && Array.isArray(parent.childItems)) {
        // Search in childItems array
        foundItem = parent.childItems.find(
          (child: any) => Number(id) === (data.isCustomFilling ? Number(child.idStr) : child.id)
        );
      } else {
        // Fallback: check parent item directly (for non-grouped structure)
        if (Number(id) === (data.isCustomFilling ? Number(parent.idStr) : parent.id)) {
          foundItem = parent;
        }
      }

      if (foundItem) break;
    }

    if (foundItem) {
      if (!isCostOn) {
        this.manufacturingForm.patchValue({ processName: foundItem, amount: data?.amount });
      } else {
        this.manufacturingForm.patchValue({
          processName: foundItem,
          amount: data?.amount,
          costPerUnit: data.costPerUnit,
          costPerPackage: data.costPerPackage,
        });
      }
    }
  }

  noSpecialKeys(event: any) {
    const allowedKeys = /^[0-9.]$/; // RegEx to allow digits and one decimal point

    if (
      event.key === 'Backspace' ||
      event.key === 'Delete' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowRight' ||
      event.key === 'ArrowDown' ||
      event.key === 'ArrowLeft'
    )
      return;

    if (!allowedKeys.test(event.key)) {
      event.preventDefault();
    }

    // logic to allow only one decimal point
    const input = event.target.value;
    const hasDecimalPoint = input.includes('.');

    if (event.key === '.' && hasDecimalPoint) {
      event.preventDefault();
    }
  }

  getCountry() {
    this.productIngredientData.country.map((item: any) => {
      if (item.id == this.productIngredientData.countryId) {
        return (this.selectesCountry = item);
      }
    });
  }

  commonInputSearchForDes(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }
  commonInputSearchForName(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }
  commonInputSearchForIngredientName(term: string, item: any) {
    return item.ingredientName.toLowerCase().includes(term.toLowerCase());
  }

  changeMaterialValue(data: any) {
    this.isCustomProcess = data.target.checked == true ? true : false;
    if (this.isCustomProcess) {
      this.manufacturingForm.controls['amount'].clearValidators();
    } else {
      this.manufacturingForm.controls['amount'].setValidators([Validators.required]);
    }
    this.manufactureItems = this.isCustomProcess
      ? this.manufactureItemsCustom
      : this.energyProcessItems;
    this.manufacturingForm.controls['processName'].setValue(null);
    this.manufacturingForm.controls['amount'].setValue('');
    this.manufacturingForm.controls['costPerPackage'].setValue(0);
    this.manufacturingForm.controls['costPerUnit'].setValue(0);
  }

  getUnitValue(data: any) {
    if (data.id) {
      this.ingredientId = data.id;
      this.getIngrientInfo();
      this.projectService
        .getUnitForProductIngredient(this.ingredientId)
        .subscribe((unitValue: any) => {
          this.ingredientDetailFormGroup.controls['ingredientUnit'].setValue(unitValue?.data);
        });
    }
  }

  updateUnit(event: any) {
    if (!event) return;
    this.ingredientDetailFormGroup.controls['ingredientUnit'].setValue(event.name);
  }

  async getIngrientInfo() {
    const tooltipData = await this.projectsService.ingredientInfo(
      this.ingredientId || 0,
      this.getCountryIdData || this.productIngredientData.countryId,
      0
    );
    this.materialInfoData = tooltipData.data;
    this.materialInfoDataKey = Object.keys(this.materialInfoData);
    this.materialInfoDataValues = Object.values(this.materialInfoData);
    this.materialname = this.materialInfoData.name;
  }

  getCountryId(event: any) {
    if (event.id) {
      this.getCountryIdData = event.id;
      this.getIngrientInfo();
    }
  }

  toTitleCase(str: any) {
    return str.replace(/\w\S*/g, (txt: any) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  getCustomTransport() {
    this.customService.getAllCustomTransportList().subscribe((res: any) => {
      this.customtransportScenarioItems = res.data;
    });
  }
  async createUniqueId(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.ingredientColumnDef[4].cellEditorParams['supplierList$'].subscribe((list: any) => {
        const filterSupplier = list.find(
          (item: any) =>
            item?.name?.toLowerCase() ===
            (this.ingredientDetailFormGroup.value.ingredientSupplier?.name?.toLowerCase() ??
              this.ingredientDetailFormGroup.value.ingredientSupplier?.toLowerCase())
        );
        if (filterSupplier) {
          resolve(filterSupplier);
        } else {
          resolve(`T${Date.now()}`);
        }
      });
    });
  }
  async checkDuplicateList(ingredientSupplierId: any): Promise<string> {
    return new Promise((resolve, reject) => {
      this.ingredientColumnDef[4].cellEditorParams['supplierList$'].subscribe((list: any) => {
        const filterSupplier = list.filter((item: any) => ingredientSupplierId === item.id);
        if (filterSupplier.length) {
          resolve('true');
        } else {
          resolve('false');
        }
      });
    });
  }

  async addIngredient() {
    this.submitForIngredient = true;
    if (this.ingredientDetailFormGroup.valid) {
      const ingredientData: any = {};
      const supplerDetail: any = await this.createUniqueId();
      ingredientData['ingredientName'] = this.ingredientDetailFormGroup.value.ingredientName.name;
      ingredientData['ingredientItemId'] = this.ingredientDetailFormGroup.value.ingredientName.id;
      ingredientData['supplierName'] =
        this.ingredientDetailFormGroup.value?.ingredientSupplier?.name ||
        (supplerDetail.name ?? this.ingredientDetailFormGroup.value?.ingredientSupplier);
      ingredientData['ingredientSupplierId'] =
        this.ingredientDetailFormGroup.value?.ingredientSupplier?.id ||
        (supplerDetail.id ?? supplerDetail);
      ingredientData['countryId'] = this.ingredientDetailFormGroup.value.ingredientCountry?.id;
      ingredientData['countryName'] = this.ingredientDetailFormGroup.value.ingredientCountry?.name;
      ingredientData['ingredientWeight'] = this.ingredientDetailFormGroup.value.ingredientWeigth;
      ingredientData['unitName'] =
        this.ingredientDetailFormGroup.value?.ingredientUnit ||
        this.ingredientDetailFormGroup.value?.ingredientUnit.name;
      this.projectFacade.proudctIngredientProcess(ingredientData, 'add', 'ingredient');
      this.ingredientDetailFormGroup.controls['ingredientName'].setValue(null);
      this.ingredientDetailFormGroup.controls['ingredientWeigth'].setValue(null);
      this.ingredientDetailFormGroup.controls['ingredientWeigth'].markAsUntouched();
      this.ingredientDetailFormGroup.controls['ingredientUnit'].setValue(null);
      const checkDuplicateSupplierRecord = await this.checkDuplicateList(
        ingredientData['ingredientSupplierId']
      );
      if (checkDuplicateSupplierRecord == 'false') {
        const supplierObj = {
          id: ingredientData['ingredientSupplierId'],
          idLong: 0,
          packageScenarioId: 0,
          name: ingredientData['supplierName'],
          selected: false,
          isCustomSiteTransport: false,
          flag: false,
          shortOrder: 0,
          isReportGeneratable: false,
          childItems: [],
        };
        const newSupplierList =
          this.ingredientColumnDef[4].cellEditorParams['supplierList$'].value || [];
        const list = [...newSupplierList, supplierObj];
        this.ingredientColumnDef[4].cellEditorParams['supplierList$'].next(list);
        this.changeDetectorRef.detectChanges();
      }
      this.ingredientDetailFormGroup.controls['ingredientSupplier'].setValue(null);
      this.submitForIngredient = false;
    }
  }

  addIngredientTransport(data: any, distanceData: any, customData: any) {
    if (this.selectLocation) {
      data = data;
      distanceData = [];
      this.CustomtransportScenarioId = undefined;
    } else if (this.selectDistance) {
      distanceData = distanceData;
      data = [];
      this.CustomtransportScenarioId = undefined;
    } else {
      data = [];
      distanceData = [];
    }
    if (this.CustomtransportScenarioId) {
      this.allCustomtransportScenarioId.push(this.CustomtransportScenarioId);
    }
    this.componentSubmitted = true;
    if (this.transportationDetailForm.controls['ingredientTransportation'].invalid) {
      return;
    } else {
      let dataList;
      data = data.map((item: any) => {
        if (typeof item.distance === 'string') {
          const type = item.distance?.substring(item.distance.indexOf(' ') + 1);
          Object.freeze(item);
          const objCopy = { ...item };
          const distanceWithoutCommas = item.distance.replace(/,/g, '');
          objCopy.distance = parseFloat(distanceWithoutCommas);
          objCopy.unit = type;
          item = objCopy;
        }
        return item;
      });
      if (distanceData) {
        distanceData = distanceData.map((item: any) => {
          return {
            ...item,
            unit: 'km',
          };
        });
      }

      dataList =
        data?.length > 0
          ? data
          : distanceData?.length > 0
          ? distanceData
          : customData?.length > 0
          ? customData
          : [];
      dataList = dataList.map((ele: any, index: any, arr: any) => {
        return {
          ...arr[index],
          imageName: arr[index].description ?? arr[index].transportModeImage,
          cityName: arr[index].originName,
        };
      });
      this.transportIcons = dataList.map((ele: any, index: any, arr: any) => {
        return arr[index] || arr[index];
      });
      this.transportaionIdArray = cloneDeep(this.transportaionIdArray);
      this.transportaionIdArray.push(this.transportaionId);
      this.transportationDetailForm.controls['ingredientTransportation'].value.forEach(
        (ele: any, i: any) => {
          this.transportaionIdArray = cloneDeep(this.transportaionIdArray);
          const payload: any = {};
          payload['ingredientName'] =
            this.transportationDetailForm.controls['ingredientTransportation'].value[
              i
            ]?.ingredientName;
          payload['transportIcons'] = this.transportIcons;
          payload['ingredientItemId'] = ele?.ingredientItemId;
          payload['transportaionId'] = this.transportaionId;
          payload['transportationIds'] = this.transportaionId;
          payload['distance'] =
            this.transportIcons
              .map((item: any) => item.distance)
              .reduce((acc: any, curr: any) => acc + curr, 0) +
            ' ' +
            'km';
          payload['locationTransportationItems'] = data.map((item: any, index: number) => {
            return {
              ...item,
              childOrder: index + 1,
              parentOrder: this.parentOrder,
            };
          });
          payload['distanceTransportationItems'] = distanceData.map((item: any, index: number) => {
            return {
              ...item,
              parentOrder: this.parentOrder,
              childOrder: index + 1,
              imageName: item.description,
              unit: 'km',
            };
          });
          const customTransportScenarioIdArr = [];
          if (
            this.CustomtransportScenarioId != null &&
            this.CustomtransportScenarioId != undefined
          ) {
            customTransportScenarioIdArr.push({
              customtransportScenarioId: this.CustomtransportScenarioId,
              parentOrder: this.parentOrder,
            });
          }
          payload['customeLocationTransportationItems'] = customTransportScenarioIdArr;

          this.parentOrder = this.parentOrder + 1;
          this.projectFacade.proudctIngredientTransportProcess(payload, 'add');
        }
      );
      this.customTransportList = null;
      this.componentSubmitted = false;
      this.ingredientFieldValue =
        this.transportationDetailForm.controls['ingredientTransportation'].value;
      this.transportationDetailForm.controls['ingredientTransportation'].setValue(null);
      this.projectFacade.clearFreightProcess();
      this.projectFacade.clearDistanceProcess();
      this.projectFacade.clearLocationProcess();
      this.transportationDetailForm.controls['customScenarioItem'].setValue(null);
      this.customFreightSelectData = null;
    }
    this.projectFacade.clearaddTransportScenarioForPackMaterialForConversion();
  }

  setFormData() {
    this.ingredientDetailFormGroup.patchValue({ ingredientCountry: this.selectesCountry });
    this.transportaionId = this.productIngredientData.transportaionIngredientId || 2;
    this.selectedBox = this.TransportationEnum.find((x: any, index: any) => {
      return this.transportaionId == this.TransportationEnum[index].id;
    });
    switch (this.selectedBox?.id) {
      case 2:
        this.wholeData[0]['img'] = this.loactionWhite;
        this.selectLocation = true;
        break;
      case 3:
        this.wholeData[1]['img'] = this.distanceWhite;
        this.selectDistance = true;
        break;
      case 4:
        this.wholeData[2]['img'] = this.customWhite;
        this.selectCustom = true;
        break;
      default:
        break;
    }
  }

  manualLocation(data: any) {
    this.selectLocation = false;
    this.selectDistance = false;
    this.selectCustom = false;
    this.isCheckEditManudalDist = false;
    this.isCheckUpdateOrigin = false;
    this.isCheckUpdateDestination = false;
    this.isCustomTruck = false;
    this.processColumnDef =
      this.productIngredientDataGridService.getTransportModalForManualLocationDataColumn();
    this.distanceProcessColumnDef =
      this.productIngredientDataGridService.getTransportModalForManualDestinationDataColumn();
    this.processColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.distanceProcessColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.wholeData[0]['img'] = this.locationBlack;
    this.wholeData[1]['img'] = this.distanceBlack;
    this.wholeData[2]['img'] = this.customBlack;
    switch (data.type) {
      case 'location':
        this.wholeData[0]['img'] = this.loactionWhite;
        this.selectedBox.id = 2;
        this.selectLocation = true;
        this.isShowCustomTransportList = false;
        this.transportaionId = 2;
        this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
        this.transportationDetailForm.controls['distance'].setValue(null);
        this.transportationDetailForm.controls['Origin'].reset();
        this.customTransportList = null;
        this.percentageMassLoad = 0;
        break;
      case 'distance':
        this.wholeData[1]['img'] = this.distanceWhite;
        this.selectedBox.id = 3;
        this.selectDistance = true;
        this.isShowDistantField = false;
        this.isShowCustomTransportList = false;
        this.transportaionId = 3;
        this.customTransportList = null;
        this.transportationDetailForm.controls['Origin'].reset();
        this.percentageMassLoad = 0;
        break;
      case 'custom':
        this.wholeData[2]['img'] = this.customWhite;
        this.selectedBox.id = 4;
        this.selectCustom = true;
        this.isShowDistantField = false;
        this.transportaionId = 4;
        this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
        this.transportationDetailForm.controls['distance'].setValue(null);
        this.transportationDetailForm.controls['transportModeForDistance'].clearValidators();
        this.transportationDetailForm.controls['distance'].clearValidators();
        this.percentageMassLoad = 0;
        this.addCustomFreight();
        break;
      default:
        break;
    }
  }
  onScroll() {
    if (this.selectedCities?.length < 50) return;
    this.pageNumber++;
    this.isLoading = true;
    this.searchCities(this.searchValue);
  }
  onKeyDownEvent(event: any) {
    if (
      this.keywordAuto == undefined ||
      this.keywordAuto == null ||
      typeof this.keywordAuto == 'object'
    ) {
      this.keywordAuto = '';
    }
    onKeyDown(event, this.keywordAuto);
  }
  onChangeSearch(searchValue: string) {
    if (this.keywordAuto == undefined || this.keywordAuto == null) {
      this.keywordAuto = '';
    }
    this.keywordAuto = this.keywordAuto?.trimStart();
    if (this.keywordAuto.length) {
      this.isLoading = true;
      this.pageNumber = 1;
      this.searchValue = this.keywordAuto;
      this.selectedCities = [];
      this.searchSubject.next(this.keywordAuto);
    }
  }

  async searchCities(searchValue: string) {
    const res: any = await this.sharedService.getAllFilterCity(
      this.pageNumber,
      searchValue,
      this.isShowPort
    );
    this.selectedCities = this.pageNumber === 1 ? res.data : [...this.selectedCities, ...res.data];
    this.autoForOrigin?.focus();
    this.autoForDestination?.focus();
    this.isLoading = false;
  }

  onClearSearch(event: any) {
    this.isLoading = false;
    this.selectedCities = [];
    this.pageNumber = 1;
    this.searchValue = '';
    this.autoForOrigin?.close();
    this.autoForDestination?.close();
  }

  changeCustomTransportItem(event: any) {
    this.projectFacade.clearFreightProcess();
    if (event?.id) {
      this.customFreightSelectData = event;
    }
  }
  resetTransport() {
    this.customFreightSelectData = null;
  }
  addCustomFreight() {
    if (this.customFreightSelectData) {
      this.CustomtransportScenarioId = this.customFreightSelectData.id;
      this.projectFacade.customFreightActions(
        this.customFreightSelectData.id,
        this.customFreightSelectData.isCustomSiteTransport
      );
    }
  }
  selectEvent(event: any) {
    this.originId = event.idStr;
    this.keywordAuto = '';
    this.selectedCities = [];
  }

  showPorts(event: any) {
    this.transportationDetailForm.controls['Origin'].setValue(null);
    this.transportationDetailForm.controls['destination'].setValue(null);
    this.isShowPort = event.target.checked;
  }

  chnageCustomTruck(event: any) {
    this.isCustomTruck = event.target.checked ? true : false;
    this.percentageMassLoad = 0;
    this.processColumnDef =
      this.productIngredientDataGridService.getTransportModalForManualLocationDataColumn();
    this.distanceProcessColumnDef =
      this.productIngredientDataGridService.getTransportModalForManualDestinationDataColumn();
    this.processColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.distanceProcessColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
    this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
  }

  getCostPerPackage() {
    const amount = this.manufacturingForm.controls['amount']?.value || 0;
    const costPerUnit = this.manufacturingForm.controls['costPerUnit']?.value || 0;
    const result = (amount * costPerUnit) / 1000;
    this.manufacturingForm.controls['costPerPackage'].setValue(result);
  }

  getCustomTruckList() {
    this.projectService.getCustomTruckList().subscribe((data: any) => {
      this.customTruckItems = data.data;
    });
  }
  getCustomFillingList() {
    this.projectService.getCustomFillingList().subscribe((data: any) => {
      this.manufactureItemsCustom = data.data;
      this.manufactureItems = this.isCustomProcess
        ? this.manufactureItemsCustom
        : this.energyProcessItems;
    });
  }

  addTransportDistance() {
    this.setManualDistanceSubmitted = true;
    if (
      this.transportationDetailForm.controls['transportModeForDistance'].value &&
      this.transportationDetailForm.controls['distance'].value &&
      this.transportationDetailForm.controls['ingredientTransportation'].valid
    ) {
      this.transportScenarioDataForDistance = {};
      this.transportScenarioDataForDistance['id'] = 0;
      if (this.isCheckEditManudalDist) {
        this.transportScenarioDataForDistance['index'] = this.ProducteditManualDistanceData.index;
      }
      this.transportScenarioDataForDistance['isCustomTruck'] = this.isCustomTruck;
      this.isCustomTruck
        ? (this.transportScenarioDataForDistance['customTruckId'] = this.transportModeId)
        : (this.transportScenarioDataForDistance['transportModeId'] = this.transportModeId);
      this.transportScenarioDataForDistance['transportModeName'] =
        this.transportationDetailForm.value.transportModeForDistance.name;
      this.transportScenarioDataForDistance['distance'] =
        this.transportationDetailForm.value.distance;
      this.transportScenarioDataForDistance['persanteageMassLoad'] = this.percentageMassLoad || 0;
      this.transportScenarioDataForDistance['transportataionId'] = this.transportaionId;
      this.transportScenarioDataForDistance['transportationId'] = this.transportaionId;
      this.transportScenarioDataForDistance['description'] = this.isCustomTruck
        ? 'Truck.png'
        : this.transportationDetailForm.controls['transportModeForDistance'].value?.description;
      this.transportScenarioDataForDistance['ingredientId'] =
        this.transportationDetailForm.controls['ingredientTransportation'].value.forEach(
          (ele: any, i: any) => {
            return ele.ingredientItemId;
          }
        );
      this.projectFacade.addDistanceTransportIngredeint(
        this.transportScenarioDataForDistance,
        this.isCheckEditManudalDist ? 'edit' : 'add'
      );
      this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
      this.transportationDetailForm.controls['distance'].setValue(null);
      this.setManualDistanceSubmitted = false;
      this.isCheckEditManudalDist = false;
    }
  }
  setOrigin() {
    this.setOriginsubmitted = true;
    if (this.transportationDetailForm.controls['Origin']?.value?.hasOwnProperty('name')) {
      this.transportScenarioData = {
        id: 0,
        originName: this.transportationDetailForm.value.Origin.name,
        distance: null,
        originId: this.originId,
        transportationId: this.transportaionId,
        unit: 'km',
        parentOrder: this.parentOrder,
      };
      this.projectFacade.addLocationProcessIngredient(
        this.transportScenarioData,
        this.isCheckUpdateOrigin ? 'edit' : 'add'
      );
      this.setOriginsubmitted = false;
      this.checkIsOrginBtn = false;
      this.isCheckUpdateOrigin = false;
      this.transportationDetailForm.controls['Origin'].reset();
    } else {
      return;
    }
  }
  getLastItem() {
    this.projectFacade.locationProcessData$.pipe(take(1)).subscribe((data: any) => {
      this.lastItem = this.isCheckUpdateDestination
        ? data[
            data.findIndex((item: any) => item.index === this.productIngredientEditData.index) - 1
          ]
        : data[data?.length - 1];
    });
  }
  changeTransportMode(event: any) {
    if (event?.id) {
      this.transportModeId = event.id;
      this.transportModeName = event.name;
      this.transportModeDescription = event.description;
      this.getLastItem();
    }
    if (event?.id && this.isCustomTruck) {
      this.getMassLoad(event);
    }
  }

  onClearSearchSupplier(event: any) {
    this.supplierId = null;
    this.isLoadingSupplier = false;
    this.searchSupplierList = [];
    event?.stopPropagation();
    this.auto.close();
  }

  onChangeSearchSupplier(search: any) {
    this.searchSupplierList = [];
    this.isLoadingSupplier = true;
    this.searchSupplier(search);
  }

  searchSupplier(search: string) {
    this.ingredientColumnDef[4].cellEditorParams['supplierList$'].subscribe((list: any) => {
      this.searchSupplierList = search
        ? list?.filter((item: any) => item.name.toLowerCase().startsWith(search.toLowerCase()))
        : [];
      this.isLoadingSupplier = false;
      if (search == '') this.supplierId = null;
    });
  }

  selectedSupplier(event: any) {
    if (!event.id) return;
    this.supplierId = event.id;
  }

  changeUnit(eve: any) {
    if (!eve.id) return;
    this.ingredientDetailFormGroup.controls['ingredientUnit'].setValue(eve.name);
  }

  async getCalculateDisForNextRecord(lastItem: any, nextItem: any) {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [lastItem],
      destinations: [nextItem.originName],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = response.rows[0].elements[0].distance?.text ?? '0 km';
          this.setManualLocationDisForNextRecord = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  changeNextRecordDistance() {
    this.projectFacade.locationProcessData$.pipe(take(1)).subscribe(async (data: any) => {
      const startIndex = data.findIndex(
        (item: any) => item.index === this.productIngredientEditData.index
      ); // Index to start checking after
      if (this.isCheckUpdateDestination && startIndex < data.length - 1) {
        let destinationNextRecord =
          data[
            data.findIndex((item: any) => item.index === this.productIngredientEditData.index) + 1
          ];
        const lastItemNextRecord = this.transportationDetailForm.value.destination;
        try {
          await this.getCalculateDisForNextRecord(lastItemNextRecord.name, destinationNextRecord);
          Object.freeze(destinationNextRecord);
          const objCopy = { ...destinationNextRecord };
          objCopy.distance = this.setManualLocationDisForNextRecord;
          destinationNextRecord = objCopy;
          this.projectFacade.addLocationProcessIngredient(destinationNextRecord, 'edit');
        } catch (error) {
          // Handle error, e.g., log it or show a user-friendly message.
          console.error('Error:', error);
        }
      }
    });
  }

  deleteSetDistanceRecord(allRecorsds: any, deleteRecord: any) {
    this.projectFacade.locationProcessData$
      .pipe(take(1))
      .subscribe(async (allManualLocationData: any) => {
        const indexToDelete = allRecorsds.findIndex(
          (record: any) => record.index === deleteRecord.index
        );
        if (indexToDelete !== -1) {
          // Delete the record
          // Create a new array excluding the deleted record
          const newArray = allRecorsds.filter((record: any, index: any) => index !== indexToDelete);
          const aboveRecord = newArray[indexToDelete - 1];
          let belowRecord = newArray[indexToDelete];
          // newArray now contains the array with the specified record deleted
          if (belowRecord) {
            await this.getCalculateDisForNextRecord(aboveRecord.originName, belowRecord);
            Object.freeze(belowRecord);
            const objCopy = { ...belowRecord };
            objCopy.distance = this.setManualLocationDisForNextRecord;
            objCopy.index = allManualLocationData[indexToDelete].index;
            belowRecord = objCopy;
            this.projectFacade.addLocationProcessIngredient(belowRecord, 'edit');
          }
        }
      });
  }

  seaDistanceMatrix(lastItem: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const fromCity = lastItem.originName;
      const toCity = this.transportationDetailForm.controls['destination'].value?.name;
      const bothCity: string[] = [fromCity, toCity];
      const geocoder = new google.maps.Geocoder();

      // Use map to create an array of observables for geocoding requests
      const geocodeRequests = bothCity.map((address: string) => {
        return new Observable(observer => {
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === 'OK') {
              const location = results![0].geometry.location;
              observer.next({ latitude: location.lat(), longitude: location.lng() });
              observer.complete();
            } else {
              observer.error(`Geocode was not successful for ${address} due to: ` + status);
            }
          });
        });
      });

      // Wait for all geocoding requests to complete
      forkJoin(geocodeRequests).subscribe(
        async (results: any[]) => {
          const [fromLocation, toLocation] = results;
          const latFrom = fromLocation.latitude;
          const lngFrom = fromLocation.longitude;
          const latTo = toLocation.latitude;
          const lngTo = toLocation.longitude;

          // Now you can make the API call
          const distanceType = this.sharedService.getDistanceTypeByTransportMode(
            this.transportModeId
          );
          const res = await this.sharedService.getDistanceAndTime(
            latFrom,
            lngFrom,
            latTo,
            lngTo,
            lastItem.originId,
            this.transportationDetailForm.controls['destination'].value?.idStr,
            distanceType
          );
          if (
            this.transportModeId == commonEnum.AIR_INTERNATIONAL ||
            this.transportModeId == commonEnum.AIR_DOMESTIC
          ) {
            this.transportationDetailForm.controls['distance'].setValue(
              formatNumber(res.data) + ' ' + 'km'
            );
            this.setManualLocationDis = formatNumber(res.data) + ' ' + 'km';
          } else if (this.transportModeId == commonEnum.SHIP_INTERNATIONAL) {
            this.seaDistance = formatNumber(res.data) + ' ' + 'km';
          }
          resolve(); // Resolve the promise once everything is done
        },
        error => {
          console.error(error);
          reject(error); // Reject the promise in case of an error
        }
      );
    });
  }
  async setDestination() {
    this.setDestinationsubmitted = true;
    if (
      this.transportationDetailForm.controls['destination']?.value?.hasOwnProperty('name') &&
      this.transportationDetailForm.controls['transportModeForLocation'].value
    ) {
      if (
        this.isCheckUpdateDestination &&
        this.transportationDetailForm.controls['distanceManulaLocation'].value == 0
      ) {
        return;
      }
      if (
        (this.transportationDetailForm.controls['destination']?.value?.name?.includes('Port') &&
          (this.lastItem?.originName?.includes('Port') || this.lastItem?.name?.includes('Port')) &&
          this.transportModeName?.toLowerCase() == commonEnum.shipName) ||
        this.transportModeName?.toLowerCase() == commonEnum.airName ||
        this.transportModeName?.toLowerCase() == commonEnum.airDomesticName
      ) {
        await this.seaDistanceMatrix(this.lastItem);
      } else {
        await this.calculateDistance(this.lastItem);
      }
      if (this.messageType != 1) {
        if (
          (this.transportationDetailForm.value.destination.idStr ||
            this.transportationDetailForm.value.destination.originId) ==
            this.productIngredientEditData?.originId &&
          this.transportModeId == this.productIngredientEditData.transportModeId
        ) {
          this.setApiResDistance = true;
        }
        !!this.productIngredientEditData?.originId &&
          (this.transportationDetailForm.value.destination.idStr ||
            this.transportationDetailForm.value.destination.originId) !=
            this.productIngredientEditData?.originId &&
          this.changeNextRecordDistance();
        this.destinationData = {};
        this.destinationData['id'] = 0;
        if (this.isCheckUpdateDestination) {
          this.destinationData['index'] = this.productIngredientEditData.index;
        }
        this.destinationData['isCustomTruck'] = this.isCustomTruck;
        this.isCustomTruck
          ? (this.destinationData['customTruckId'] = this.transportModeId)
          : (this.destinationData['transportModeId'] = this.transportModeId);
        this.destinationData['transportModeName'] =
          this.transportationDetailForm.value.transportModeForLocation.name;
        this.destinationData['persanteageMassLoad'] = this.percentageMassLoad || 0;
        const newManualLocationDisatance =
          this.transportationDetailForm.controls['distanceManulaLocation'].value;
        const getDisType =
          typeof this.productIngredientEditData?.distance == 'string' &&
          !!this.productIngredientEditData?.distance
            ? this.productIngredientEditData?.distance?.substring(
                this.productIngredientEditData.distance.indexOf(' ') + 1
              )
            : 'km';
        const newVal = newManualLocationDisatance + ' ' + (getDisType == '0' ? ' ' : getDisType);

        if (this.transportModeName.toLowerCase() == commonEnum.shipName) {
          this.destinationData['distance'] =
            this.isCheckUpdateDestination && this.setApiResDistance ? newVal : this.seaDistance;
        } else {
          this.destinationData['distance'] =
            this.isCheckUpdateDestination && this.setApiResDistance
              ? newVal
              : this.setManualLocationDis;
        }

        this.destinationData['originId'] =
          this.transportationDetailForm.value.destination.idStr ||
          this.transportationDetailForm.value.destination.originId;
        this.destinationData['idStr'] = this.destinationData['originId'];
        this.destinationData['originName'] = this.transportationDetailForm.value.destination.name;
        this.destinationData['description'] = this.isCustomTruck
          ? 'Truck.png'
          : this.transportationDetailForm.controls['transportModeForLocation'].value?.description;
        this.destinationData['isOrigin'] = this.isCheckUpdateDestination
          ? this.productIngredientEditData.isOrigin
          : true;
        this.destinationData['transportataionId'] = this.transportaionId;
        this.destinationData['transportationId'] = this.transportaionId;
        this.setDestinationsubmitted = false;
        this.transportationDetailForm.controls['destination'].setValue('');
        this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
        this.projectFacade.addLocationProcessIngredient(
          this.destinationData,
          this.isCheckUpdateDestination ? 'edit' : 'add'
        );
        this.setOriginsubmitted = false;
        this.isCheckUpdateDestination = false;
        this.setApiResDistance = false;
        this.messageType = 0;
        this.isValidPort = '';
      } else if (this.messageType == 1) {
        this.transportationDetailForm.controls['transportModeForLocation'].reset();
        this.setDestinationsubmitted = false;
        this.messageType = 0;
      } else {
        this.setDestinationsubmitted = true;
      }
    } else {
      this.setDestinationsubmitted = true;
    }
  }

  getMassLoad(event: any) {
    if (event.id) {
      this.projectsService.getTruckMassLoad(event.id || event.truckId).subscribe((res: any) => {
        this.percentageMassLoad = res.data.percenteageMassLoad;
      });
    }
  }

  addProcess() {
    this.submitForManufacture = true;
    if (this.manufacturingForm.valid) {
      const payload: any = {};
      payload['fillingProcessName'] = this.manufacturingForm.controls['processName'].value.name;
      payload['amount'] = Number(this.manufacturingForm.controls['amount'].value);
      payload['costPerUnit'] = this.manufacturingForm.controls['costPerUnit']?.value;
      payload['costPerPackage'] = this.manufacturingForm.controls['costPerPackage']?.value;
      payload['isCustomFilling'] = this.isCustomProcess;
      if (this.manufactureEditMode) {
        payload['index'] = this.editManufactureData.index;
      }
      this.isCustomProcess
        ? (payload['customFillingId'] = this.manufacturingForm.value.processName?.idStr)
        : (payload['energyProcessId'] = this.manufacturingForm.value.processName?.id);
      this.projectFacade.proudctIngredientManufactureProcess(
        payload,
        this.manufactureEditMode ? 'edit' : 'add'
      );
      this.submitForManufacture = false;
      this.manufacturingForm.controls['processName'].setValue(null);
      this.manufacturingForm.controls['amount'].setValue('');
      this.manufacturingForm.controls['amount'].markAsUntouched();
      this.manufacturingForm.controls['costPerPackage'].setValue(0);
      this.manufacturingForm.controls['costPerUnit']?.setValue(0);
      this.manufactureEditMode = false;
    }
  }

  onClose() {
    this.projectFacade.clearProudctIngredientProcess();
    this.projectFacade.clearFillingProcess();
    this.projectFacade.clearDistanceProcess();
    this.projectFacade.clearFreightProcess();
    this.projectFacade.clearDistanceProcess();
    this.projectFacade.clearLocationProcess();
    this.projectFacade.clearAllReplicaList();
    this.modal.close();
  }

  getMapingData(ele: any) {
    const mappingData = ele.locationTransportationItems
      .concat(ele.distanceTransportationItems, ele.customeLocationTransportationItems)
      .sort((item1: any, item2: any) => item1.parentOrder - item2.parentOrder);
    //   let mappingData = ele.locationTransportationItems.concat(ele.distanceTransportationItems, ele.customeLocationTransportationItems ? ele.customeLocationTransportationItems : []
    // ).sort((item1:any, item2:any) => item1?.parentOrder - item2?.parentOrder);
    const uniqueParents = [...new Set(mappingData.map((item: any) => item?.parentOrder))].sort(
      (a: any, b: any) => a - b
    );
    const parentMapping: any = {};
    uniqueParents.forEach((value: any, index: any) => {
      parentMapping[value] = index + 1;
    });

    // Step 3: Transform the original array using the mapping, keeping all properties intact
    const transformedData = mappingData.map((item: any) => ({
      ...item,
      parentOrder: parentMapping[item.parentOrder],
    }));

    return transformedData;
  }

  saveData(
    getManufacturProcess: any,
    getIngredientItems: any,
    replicaLocation: any,
    replicaDistance: any,
    getIngredientTransportItems: any
  ) {
    getIngredientTransportItems = cloneDeep(getIngredientTransportItems);
    getIngredientItems = cloneDeep(getIngredientItems);
    this.submitForIngredient = true;
    this.componentSubmitted = true;
    // replicaLocation = replicaLocation.map((item: any) => {
    //   if (typeof item.distance === 'string' && item.distance != 0) {
    //     const type = item.distance?.substring(item.distance.indexOf(' ') + 1);
    //     Object.freeze(item);
    //     const objCopy = { ...item };
    //     objCopy.distance = parseFloat(item.distance.replace(type, ''));
    //     objCopy.unit = type;
    //     item = objCopy;
    //   } else {
    //     Object.freeze(item);
    //     const objCopy = { ...item };
    //     objCopy.unit = "km";
    //     item = objCopy;
    //   }
    //   return item;
    // });

    // if (!!replicaDistance) {
    //   replicaDistance = replicaDistance.map((item: any) => {
    //     return {
    //       ...item,
    //       unit: "km"
    //     }
    //   })
    // }
    getIngredientTransportItems.forEach((ele: any, i: any) => {
      if (ele.customeLocationTransportationItems) {
        const idToParentOrderMap = new Map();
        ele.customeLocationTransportationItems.forEach((item: any) => {
          if (!idToParentOrderMap.has(item.customtransportScenarioId)) {
            idToParentOrderMap.set(item.customtransportScenarioId, item.parentOrder);
          }
        });

        // Convert the Map back to an array of objects
        ele.customeLocationTransportationItems = Array.from(
          idToParentOrderMap,
          ([customtransportScenarioId, parentOrder]) => ({ customtransportScenarioId, parentOrder })
        );
      }
      const productData: any = {};
      const allTransportRec = this.getMapingData(ele);
      let location: any = [];
      let distance: any = [];
      const custom: any = [];

      // Grouping the records based on transport id
      allTransportRec.forEach((item: any) => {
        switch (item.transportationId) {
          case 2:
            location.push(item);
            break;
          case 3:
            distance.push(item);
            break;
          default:
            custom.push(item);
            break;
        }
      });
      ele.locationTransportationItems = location;
      ele.distanceTransportationItems = distance;
      ele.customeLocationTransportationItems = custom;
      productData['transportaionIngredientId'] =
        ele?.ingredientItemId || ele?.transportaionIngredientId;
      productData['locationTransportationItems'] = ele.locationTransportationItems;
      productData['distanceTransportationItems'] = ele.distanceTransportationItems;
      productData['customeLocationTransportationItems'] = ele.customeLocationTransportationItems;
      this.tempData.push(productData);
      location = [];
      distance = [];
    });
    if (getIngredientItems.length > 0) {
      getIngredientItems = getIngredientItems.map((item: any) => {
        if (
          typeof item.ingredientSupplierId === 'string' &&
          item.ingredientSupplierId.startsWith('T')
        ) {
          return {
            ...item,
            ingredientSupplierId: 0,
          };
        } else {
          return item;
        }
      });
      const mainPayload: any = {};
      mainPayload['productId'] = this.productIngredientData.productId || 0;
      mainPayload['productIngredientItems'] = getIngredientItems;
      mainPayload['fillingProcessItems'] = getManufacturProcess;
      mainPayload['productData'] = this.tempData;
      this.saveNewProductIngredientEvent.emit(mainPayload);
      this.parentOrder = 1;
      this.modal.close();
      this.projectFacade.clearProudctIngredientProcess();
      this.projectFacade.clearTransportScenario();
      this.projectFacade.clearAllReplicaList();
      this.projectFacade.clearFillingProcess();
      this.projectFacade.clearDistanceProcess();
      this.projectFacade.clearFreightProcess();
      this.projectFacade.clearLocationProcess();
    }
  }

  async calculateDistance(lastItem?: any) {
    const payload = {
      origin: lastItem.originName,
      destination: this.transportationDetailForm.controls['destination'].value.name,
      destinationId: Number(this.transportationDetailForm.controls['destination'].value.idStr),
      iscustomtruck: this.isCustomTruck,
      transportmodeId: this.transportModeId,
      customTransoportScenarioDetails: [
        {
          id: 0,
          cityId: lastItem.originId,
          cityName: lastItem.originName,
          transportModeName: this.transportModeName,
          customTransportScenarioId: 0,
          imageName: lastItem.description,
        },
      ],
    };
    const response = await this.customService.getSeaDistanceForTransportAsync(payload);
    if (
      (response.data.distance >= 0 && response.data.isShip) ||
      response?.message.includes('must be a valid Port')
    ) {
      this.transportationDetailForm.controls['distance'].setValue(response?.data.distance);
      const setManualLocationDis = response?.data.distance;
      this.setManualLocationDis = setManualLocationDis;
      this.isValidPort = response.message;
      this.messageType = response.messageType;
      // this.customFacade.setCustomTransportError('');
      return response;
    } else {
      await this.getCalculateDis();
    }
  }

  async getCalculateDis() {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [this.lastItem.originName],
      destinations: [this.transportationDetailForm.controls['destination'].value.name],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = response.rows[0].elements[0].distance?.text ?? '0 km';
          this.transportationDetailForm.controls['distance'].setValue(distance);
          this.setManualLocationDis = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  ngOnDestroy() {
    this.searchSubject.complete();
    this.projectFacade.clearaddTransportScenarioForPackMaterialForConversion();
    this.editProductManufactureSubscription.unsubscribe();
    this.deleteProductManufactureSubscription.unsubscribe();
  }
}
